import { JoinTextItem } from "../../../../domain/document/items";
import { AbstractTextObjectStyleReader } from ".";
import { PaintStyle, TextStyle } from "../../../../domain/drawing";
import {
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IObjectColorConfiguration,
  IJoinTextObjectStyleConfiguration,
  IEnableConfiguration,
} from "../../../../domain/configuration";

export class JoinTextObjectStyleReader extends AbstractTextObjectStyleReader<JoinTextItem> {
  constructor(private readonly _configuration: IJoinTextObjectStyleConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: JoinTextItem, shouldInputFree: boolean): PaintStyle {
    return null;
  }

  protected readBackgroundColorConfiguration(source: JoinTextItem, shouldInputFree: boolean): IBackgroundColorConfiguration {
    return this.readObjectStyleConfiguration(source, shouldInputFree);
  }

  protected readBorderColorConfiguration(source: JoinTextItem, shouldInputFree: boolean): IBorderColorConfiguration {
    return this.readObjectStyleConfiguration(source, shouldInputFree);
  }

  private readObjectStyleConfiguration(source: JoinTextItem, shouldInputFree: boolean): IObjectColorConfiguration {
    return (source.shouldInputFree || (source.isFreeInputable && shouldInputFree))
      ? this._configuration.default
      : this._configuration.joinText;
  }

  public readTextStyle(source: JoinTextItem, shouldInputFree: boolean, isFocused: boolean): TextStyle {
    return isFocused
      ? this.toFreeInputTextStyle(source)
      : this.toTextStyle(source);
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return this._configuration.foreground;
  }
}
